import React from 'react'

import { Account } from '@pages/Trade/types'

import { Truncate } from '@ui/Truncate/Truncate'
import { Body2, Caption2 } from '@ui/Typography'
import { Badge } from '@ui/components/Badge/Badge'
import { CaretIcon } from '@ui/icons/Caret.icon'

import { AccountGroupType } from '@model/AccountGroupType'

import styles from './TradingAccountSelector.module.scss'

type TradingAccountSelectorProps = {
  account: Account
  onClick?: () => void
}
export const TradingAccountSelector: React.FC<TradingAccountSelectorProps> = ({
  account,
  onClick,
}) => {
  return (
    <div className={styles.tradingAccountSelectorWrapper} onClick={onClick}>
      <AccountHeader account={account} />
      <CaretIcon.Down size={12} />
    </div>
  )
}
const AccountHeader = ({ account }: { account: Account }) => {
  const isLive = account.accountGroupType?.id === AccountGroupType.Live

  const badge = (
    <Badge size={'xxs'} type={isLive ? 'purple' : 'orange'} contrast='high'>
      <Caption2 className={styles.caps}>{isLive ? 'LIVE' : 'DEMO'}</Caption2>
    </Badge>
  )

  const title = (
    <Body2 className={styles.title}>
      <Truncate>{account.nickname || account.name}</Truncate>
    </Body2>
  )

  return (
    <div className={styles.tradingAccountHeaderWrapper}>
      <>
        {badge}
        {title}
      </>
    </div>
  )
}
